import { forwardRef, HTMLAttributes } from "react";
import cn from "clsx";

export type CardPadding = "none" | "sm" | "md";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padding?: CardPadding;
  /** Klickbare Karte: dezenter Border-Akzent + transition-colors beim Hover
   *  (Spec §Motion: 120–180ms, prefers-reduced-motion global respektiert). */
  interactive?: boolean;
}

const PADDING: Record<CardPadding, string> = {
  none: "",
  sm: "p-3",
  md: "p-5",
};

/** Standard-Karte: bg-surface + Border + rounded-xl (Spec §3, Radius-System). */
export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { padding = "md", interactive = false, className, children, ...rest },
  ref
) {
  return (
    <div
      ref={ref}
      className={cn(
        "bg-surface border border-border rounded-xl",
        interactive &&
          "transition-colors duration-150 hover:border-accent-300 cursor-pointer",
        PADDING[padding],
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
});

export default Card;
